import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';
import Input from '@mui/material/Input';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import facePageStyles from '../assets/jss/crm/views/facePageStyles';

import StateSelector from './StateSelector';

const addressPanelStyles = (theme) => ({
  ...facePageStyles(theme),

  formFramework_addressItem: {},
  addressEdit: {
    display: 'flex',
    flexDirection: 'column',
    '&$addressEdit_narrow': {
      '& $addressEdit_row': {
        marginTop: 0,
      },
    },
  },
  addressEdit_narrow: {},
  addressEdit_row: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '5px',
  },
  addressEdit_street: {
    flexBasis: '100%',
  },
  addressEdit_city: {
    // paddingRight: "10px",
    marginTop: '15px',
    flexBasis: '100%',
  },
  addressEdit_state: {
    flexBasis: '120%',
    transform: 'scale(0.8) translate(-22px, 4px)',
  },
  addressEdit_zip: {
    marginTop: '18px',
    paddingLeft: '10px',
    flexBasis: '40%',
  },
  validatedTextField: {
    position: 'relative',
  },
});

class FacePageAddressPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editingAddress: false,
      preEditAddress: undefined,
    };
  }

  handleClickInsideAddress() {
    const preEditAddress = this.state.preEditAddress || this.props.address;
    this.setState({ editingAddress: true, preEditAddress });
  }

  handleClickOutsideAddress() {
    const changed = !this.addressesAreEqual(this.props.address, this.state.preEditAddress);
    this.setState({ editingAddress: false, preEditAddress: undefined });
    this.props.onClickAway(changed);
  }

  addressesAreEqual(addr1, addr2) {
    return (
      addr1.street === addr2.street &&
      addr1.city === addr2.city &&
      addr1.state === addr2.state &&
      addr1.zip === addr2.zip
    );
  }

  render() {
    const { classes, address } = this.props;
    const { onStreetChange, onCityChange, onStateChange, onZipChange } = this.props;
    return (
      <ClickAwayListener
        onClickAway={() => this.handleClickOutsideAddress()}
        mouseEvent={this.state.editingAddress ? 'onMouseUp' : false}
      >
        <div className={cx(classes.formFramework_item, classes.formFramework_addressItem)}>
          <div className={cx(classes.addressEdit_narrow, classes.addressEdit)}>
            <div className={classes.addressEdit_row}>
              <div className={cx(classes.validatedTextField, classes.addressEdit_street)}>
                <Input
                  fullWidth={true}
                  placeholder="Street"
                  value={address.street || ''}
                  onChange={(event) => onStreetChange(event.target.value)}
                  inputProps={{ className: classes.textFieldSupplement }}
                  onMouseDown={() => this.handleClickInsideAddress()}
                />
              </div>
            </div>
            <div className={classes.addressEdit_row}>
              <div className={cx(classes.validatedTextField, classes.addressEdit_city)}>
                <Input
                  fullWidth={true}
                  placeholder="City"
                  value={address.city || ''}
                  onChange={(event) => onCityChange(event.target.value)}
                  inputProps={{ className: classes.textFieldSupplement }}
                  onMouseDown={() => this.handleClickInsideAddress()}
                />
              </div>
            </div>
            <div className={classes.addressEdit_row}>
              <div
                className={cx(classes.validatedTextField, classes.addressEdit_state)}
                onMouseDown={() => this.handleClickInsideAddress()}
              >
                <StateSelector value={address.state} onChange={(newValue) => onStateChange(newValue)} />
              </div>
              <div className={cx(classes.validatedTextField, classes.addressEdit_zip)}>
                <Input
                  fullWidth={true}
                  placeholder="Zip Code"
                  value={address.zip || ''}
                  onChange={(event) => onZipChange(event.target.value.trim())}
                  inputProps={{ className: classes.textFieldSupplement }}
                  onMouseDown={() => this.handleClickInsideAddress()}
                />
              </div>
            </div>
          </div>
        </div>
      </ClickAwayListener>
    );
  }
}

export default withStyles(addressPanelStyles)(FacePageAddressPanel);
